import React from 'react'
import { PapelSocialWrapper } from '../style'
import { Col, Label, Row } from 'reactstrap'

const PapelSocial = () => {
  return (
    <PapelSocialWrapper id="papel-social">
      <div className="container">
        <h2>Nosso Papel Social</h2>
        <h3>
          Com ações simples, ajudamos a transformar <br /> realidades e
          fortalecer um futuro mais
          <br /> humano.
        </h3>
        <Row className="d-flex row-gap-20">
          <Col xl={6}>
            <div className="card-projeto">
              <img
                className="mb-4 card-projeto-img"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/social_1.png"
                height="auto"
              />
              <div>
                <Label className="title">Nadando na Frente</Label>
                <div className="social">@projetonadandonafrente</div>
                <span className="subtitle">
                  Transformando vidas através da natação e da educação.
                </span>
                <p>
                  Mais do que um esporte, o projeto Nadando na Frente oferece
                  aulas gratuitas de natação para crianças e adolescentes em
                  situação de vulnerabilidade social.
                </p>
              </div>
            </div>
          </Col>
          <Col xl={6}>
            <div className="card-projeto">
              <img
                className="mb-4 card-projeto-img"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/social_3.png"
                height="auto"
              />
              <div>
                <Label className="title">
                  Judô – Um Golpe de Solidariedade
                </Label>
                <div className="social">@rogerio_quintela</div>
                <span className="subtitle">
                  Educação, disciplina e cidadania através do esporte.
                </span>
                <p>
                  O projeto utiliza o judô como ferramenta de desenvolvimento
                  social para jovens e crianças. Mais do que ensinar técnicas,
                  promove valores como respeito, esforço, amizade e
                  solidariedade.
                </p>
              </div>
            </div>
          </Col>
          <Col xl={6}>
            <div className="card-projeto">
              <img
                className="mb-4 card-projeto-img"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/social_2.png"
              />
              <div>
                <Label className="title">Projeto Fada</Label>
                <div className="social">@fadarp</div>
                <span className="subtitle">
                  Levando esperança, alegria e dignidade para pacientes
                  oncológicos.
                </span>
                <p>
                  O Projeto Fada atua com ações humanitárias e de apoio para
                  pessoas com deficiência. O projeto transforma momentos
                  difíceis em experiências mais leves e cheias de afeto.
                </p>
              </div>
            </div>
          </Col>
          <Col xl={6}>
            <div className="card-projeto">
              <img
                className="mb-4 card-projeto-img"
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/social_4.png"
                height="auto"
              />
              <div>
                <Label className="title">Asilo São José</Label>
                <div className="social">@asilosaojosecolina</div>
                <span className="subtitle">
                  Cuidar de quem tanto já cuidou.
                </span>
                <p>
                  O Asilo São José acolhe idosos com carinho, respeito e
                  estrutura digna. A Riber contribui com doações, apoio
                  logístico e ações de voluntariado, promovendo uma velhice mais
                  segura, ativa e acolhedora para todos os residentes.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </PapelSocialWrapper>
  )
}

export default PapelSocial
